import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Typography, message, Button, Input } from "antd";
import { platformApi } from "../../../../api";
import ImageUploader from "../../Vehicles/VehicleForm/InsuranceForm/Uploader";

const { Title } = Typography;

const documentTypes = [
  { key: "front", label: "Front View" },
  { key: "rear", label: "Rear View" },
  { key: "chassis", label: "Chassis Photo" },
  { key: "left", label: "Left View" },
  { key: "right", label: "Right View" },
  { key: "delivery", label: "Delivery Photo" },
  { key: "battery", label: "Battery Photo" },
];

const GatepassModal = ({ open, close, data }) => {

  const [gatepassData, setGatepassData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileLists, setFileLists] = useState({});
  const [imageUrls, setImageUrls] = useState({});
  const [batteryNo, setBatteryNo] = useState("");

  useEffect(() => {
    if (data) {
      console.log("DEBUG: GatepassModal Data Prop:", data);
      if (data.vehicleId || (data.vehicle && data.vehicle.id)) {
        fetchGatepassData();
      } else {
        console.warn("DEBUG: GatepassModal - No vehicleId found in data object!");
      }
    }
  }, [data]);

  useEffect(() => {
    const initialFileLists = {};
    const initialImageUrls = {};

    gatepassData.forEach((item) => {
      console.log(`DEBUG: Mapping Gatepass Item ${item.type}:`, item);
      initialFileLists[item.type] = [
        {
          uid: item.id,
          name: `${item.type}_view`,
          status: "done",
          url: item.url,
          type: "image",
          timestamp: item.createdAt,
        },
      ];
      initialImageUrls[item.type] = item.url;
    });

    console.log("DEBUG: Constructed FileLists in GatepassModal:", initialFileLists);

    // Initialize empty arrays for types that don't have data
    documentTypes.forEach((type) => {
      if (!initialFileLists[type.key]) {
        initialFileLists[type.key] = [];
      }
      if (!initialImageUrls[type.key]) {
        initialImageUrls[type.key] = null;
      }
    });

    setFileLists(initialFileLists);
    setImageUrls(initialImageUrls);
  }, [gatepassData]);

  const fetchGatepassData = () => {
    setLoading(true);
    const vId = data?.vehicleId || data?.vehicle?.id;
    platformApi
      .get(`/api/saleRegister/gatepass/${vId}`)
      .then((res) => {
        console.log("DEBUG: Gatepass API Response:", res.data);
        if (res.data.code === 200) {
          setGatepassData(res.data.data);
          setBatteryNo(res.data.batteryNo);
        } else {
          message.error("Failed to fetch gatepass data");
        }
      })
      .catch((error) => {
        console.error("Error fetching gatepass data:", error);
        message.error("Error fetching gatepass data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFileListChange = (type, fileList) => {
    setFileLists((prev) => ({
      ...prev,
      [type]: fileList,
    }));
  };

  const handleImageUrlChange = (type, url) => {
    setImageUrls((prev) => ({
      ...prev,
      [type]: url,
    }));
  };

  const handleUploadSuccess = (fileInfo) => {
    const { id, url, type, timestamp } = fileInfo;
    setGatepassData((prev) => {
      const existingIndex = prev.findIndex((item) => item.type === type);
      if (existingIndex > -1) {
        const newData = [...prev];
        newData[existingIndex] = { ...newData[existingIndex], id, url, createdAt: timestamp };
        return newData;
      } else {
        return [...prev, { id, type, url, createdAt: timestamp }];
      }
    });
  };

  // New function to handle file deletion and update gatepassData
  const handleFileDelete = (type, fileId) => {
    // Remove from gatepassData state by type to ensure only the selected view is removed
    setGatepassData((prev) => prev.filter((item) => item.type !== type));

    // Also update fileLists and imageUrls immediately
    setFileLists((prev) => ({
      ...prev,
      [type]: [],
    }));
    setImageUrls((prev) => ({
      ...prev,
      [type]: null,
    }));
  };

  const handleOk = () => {
    if (batteryNo) {
      platformApi
        .put(`/api/vehicle/batteryNo/${data.vehicleId}`, { batteryNo })
        .then((res) => {
          if (res.data.code === 200) {
            // message.success("Battery Number saved successfully");
            close();
          } else {
            message.error("Failed to save Battery Number");
          }
        })
        .catch((error) => {
          console.error("Error saving battery number:", error);
          message.error("Error saving Battery Number");
        });
    } else {
      close();
    }
  };

  const handleCancel = () => {
    close();
  };

  const hasDataForType = (type) => {
    return gatepassData.some((item) => item.type === type);
  };

  return (
    <Modal
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Upload Photos
          </Title>
          <div
            style={{
              display: "flex",
              gap: "40px",
              marginTop: "10px",
              fontSize: "14px",
              fontWeight: "normal",
            }}
          >
            <span>
              <strong>Customer:</strong>{" "}
              {data?.customer?.name || data?.customerName}
            </span>
            <span>
              <strong>Vehicle:</strong>{" "}
              {data?.vehicle?.modelName || data?.vehicleModel}
            </span>
            <span>
              <strong>Chassis No:</strong> {data?.chassisNumber}
            </span>
          </div>
        </div>
      }
      visible={open}
      onCancel={handleCancel}
      width={900}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="ok" type="primary" onClick={handleOk}>
          OK
        </Button>,
      ]}
    >
      <>
        <Form layout="vertical">
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            {documentTypes.slice(0, 3).map((docType) => (
              <Col span={8} key={docType.key}>
                <Form.Item label={docType.label}>
                  <ImageUploader
                    type={docType.key}
                    fileList={fileLists[docType.key] || []}
                    setFileList={(fileList) =>
                      handleFileListChange(docType.key, fileList)
                    }
                    imageUrl={imageUrls[docType.key]}
                    setImageUrl={(url) => handleImageUrlChange(docType.key, url)}
                    editable={true}
                    id={data?.vehicleId || data?.vehicle?.id}
                    setLoading={setLoading}
                    onFileDelete={(fileId) =>
                      handleFileDelete(docType.key, fileId)
                    }
                    onUploadSuccess={handleUploadSuccess}
                  />
                </Form.Item>
              </Col>
            ))}
          </Row>

          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            {documentTypes.slice(3, 6).map((docType) => (
              <Col span={8} key={docType.key}>
                <Form.Item label={docType.label}>
                  <ImageUploader
                    type={docType.key}
                    fileList={fileLists[docType.key] || []}
                    setFileList={(fileList) =>
                      handleFileListChange(docType.key, fileList)
                    }
                    imageUrl={imageUrls[docType.key]}
                    setImageUrl={(url) => handleImageUrlChange(docType.key, url)}
                    editable={true}
                    id={data?.vehicleId || data?.vehicle?.id}
                    setLoading={setLoading}
                    onFileDelete={(fileId) =>
                      handleFileDelete(docType.key, fileId)
                    }
                    onUploadSuccess={handleUploadSuccess}
                  />
                </Form.Item>
              </Col>
            ))}
          </Row>

          <Row gutter={[16, 16]}>
            {documentTypes.slice(6, 7).map((docType) => (
              <Col span={8} key={docType.key}>
                <Form.Item label={docType.label}>
                  <ImageUploader
                    type={docType.key}
                    fileList={fileLists[docType.key] || []}
                    setFileList={(fileList) =>
                      handleFileListChange(docType.key, fileList)
                    }
                    imageUrl={imageUrls[docType.key]}
                    setImageUrl={(url) => handleImageUrlChange(docType.key, url)}
                    editable={true}
                    id={data?.vehicleId || data?.vehicle?.id}
                    setLoading={setLoading}
                    onFileDelete={(fileId) =>
                      handleFileDelete(docType.key, fileId)
                    }
                    onUploadSuccess={handleUploadSuccess}
                  />
                </Form.Item>
              </Col>
            ))}
            <Col span={8}>
              <Form.Item label="Battery Number">
                <Input
                  placeholder="Enter Battery Number"
                  value={batteryNo}
                  onChange={(e) => setBatteryNo(e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {/* PDF Button aligned to the right */}
        {gatepassData.length === 6 && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <Button
              key="pdf"
              className="linkylink"
              target="_blank"
              rel="noopener noreferrer"
              href={`/api/saleRegister/generatePDF/${data?.saleId}`}
            >
              Download PDF
            </Button>
          </div>
        )}
      </>

    </Modal>
  );
};

export default GatepassModal;